import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PropertyCard from './PropertyCard';
import './FeaturedListings.css';

const FeaturedListings = () => {
  const [featuredProperties, setFeaturedProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFeaturedProperties = async () => {
      try {
        const response = await axios.get('/api/properties/featured/list');
        setFeaturedProperties(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching featured properties:', error);
        setError('Unable to load featured properties');
        setLoading(false);
      }
    };

    fetchFeaturedProperties();
  }, []);

  if (loading) {
    return (
      <section className="featured-listings">
        <div className="container">
          <h2>Propiedades Destacadas</h2>
          <p className="loading-text">Cargando propiedades...</p>
        </div>
      </section>
    );
  }

  // Don't show the section if there's an error
  if (error) {
    console.error('Featured listings error:', error);
    return null;
  }

  // Don't show the section if there are no featured properties
  if (featuredProperties.length === 0) {
    return null;
  }

  return (
    <section className="featured-listings">
      <div className="container">
        <div className="featured-grid">
          {featuredProperties.map((property) => (
            <PropertyCard key={property.id} property={property} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedListings;
